import { UserInfoItems } from '../../../models/user-info'
import { PortableAPI } from './portable-api'
import { MissingInfoApi } from './missing-info-api'
import { URLConfig } from '../configs/base'
import { initUserData } from '../../../config/user-info-config'
import { NotificationAPI } from './notification-api'
import { KoreaProfileRefresh } from './korea-profile-refresh'
import { KoreaCheckJson } from './korea-check-json'
import { CartAPI } from './cart-api'
import { LoyaltyPointsAPI } from './loyalty-points-api'

let apiInstance: PortableAPI
export class UserInformation {
	protected _userData
	constructor(urlConfig: URLConfig) {
		this._userData = initUserData(urlConfig)
	}

	// Consolidate getter logic
	protected async _getPortableApi(name: string, dependency?) {
		const apiData = this._userData[name]
		apiData.dependentInstance = dependency

		// Create customized PortableAPI labeled for each type: Profile, vehicle ...
		if (apiInstance === undefined || apiInstance._item !== apiData.item) {
			apiInstance = new PortableAPI(apiData)
		}

		// create a copy of the instance and add to session storage
		if (apiInstance._item === apiData.item) {
			return apiInstance.getInterface()
		}
	}

	//Notification API specific getter
	protected async _getNotificationAPI(name: string) {
		const apiData = this._userData[name]

		// Create customized PortableAPI labeled for Notification
		if (apiInstance === undefined || apiInstance._item !== apiData.item) {
			apiInstance = new NotificationAPI(apiData)
		}

		//Get the interface of the custom Notification API
		if (apiInstance._item === apiData.item) {
			return apiInstance.getInterface()
		}
	}

	//Loyalty points API specific getter (NA rewards with custom headers)
	protected async _getLoyaltyPointsAPI(name: string) {
		const apiData = this._userData[name]

		if (apiInstance === undefined || apiInstance._item !== apiData.item) {
			apiInstance = new LoyaltyPointsAPI(apiData)
		}

		if (apiInstance._item === apiData.item) {
			return apiInstance.getInterface()
		}
	}

	//Cart API specific getter
	protected async _getCartAPI(name: string) {
		const apiData = this._userData[name]

		// Create customized PortableAPI labeled for Cart
		if (apiInstance === undefined || apiInstance._item !== apiData.item) {
			apiInstance = new CartAPI(apiData)
		}

		//Get the interface of the custom Cart API
		if (apiInstance._item === apiData.item) {
			return apiInstance.getInterface()
		}
	}

	protected async _getKoreaProfileRefresh(name: string) {
		const apiData = this._userData[name]

		// Create customized PortableAPI labeled for Cart
		if (apiInstance === undefined || apiInstance._item !== apiData.item) {
			apiInstance = new KoreaProfileRefresh(apiData)
		}

		//Get the interface of the custom Cart API
		if (apiInstance._item === apiData.item) {
			return apiInstance.getInterface()
		}
	}

	protected async _getKoreaCheckJson(name: string) {
		const apiData = this._userData[name]

		// Create customized PortableAPI labeled for Cart
		if (apiInstance === undefined || apiInstance._item !== apiData.item) {
			apiInstance = new KoreaCheckJson(apiData)
		}

		//Get the interface of the custom Cart API
		if (apiInstance._item === apiData.item) {
			return apiInstance.getInterface()
		}
	}

	get profile() {
		return this._getPortableApi(UserInfoItems.profile)
	}

	get rewards() {
		if (this._userData.rewards.useLoyaltyHeaders) {
			return this._getLoyaltyPointsAPI(UserInfoItems.rewards)
		}
		return this._getPortableApi(UserInfoItems.rewards)
	}

	get missingInfo() {
		return this._getPortableApi(UserInfoItems.missingInfo, new MissingInfoApi())
	}

	get vehicles() {
		return this._getPortableApi(UserInfoItems.vehicles)
	}

	get notifications() {
		return this._getNotificationAPI(UserInfoItems.notifications)
	}

	get cart() {
		return this._getCartAPI(UserInfoItems.cart)
	}

	get koreaProfileRefresh() {
		return this._getKoreaProfileRefresh(UserInfoItems.koreaProfileRefresh)
	}

	get koreaCheckJson() {
		return this._getKoreaCheckJson(UserInfoItems.koreaCheckJson)
	}
}
